import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/common";
import { Award } from "lucide-react";

const STATUS_STYLE = {
  "Valid": "bg-emerald-100 text-emerald-700", "No Expiry": "bg-slate-100 text-slate-600",
  "Expiring Soon": "bg-amber-100 text-amber-700", "Expired": "bg-red-100 text-red-700",
  "Missing": "bg-red-50 text-red-600 border border-red-200",
};

export default function MyTraining() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/training/mine").then((r) => setData(r.data)).catch(() => setData({ linked: false, items: [] })); }, []);

  return (
    <div>
      <PageHeader title="My Training" subtitle="Your certifications, expiry dates and anything outstanding." testid="my-training-header" />
      {!data ? null : !data.linked ? (
        <EmptyState icon={Award} title="No linked profile" message="Your login isn't linked to a team profile yet. Ask your manager." />
      ) : data.items.length === 0 ? (
        <EmptyState icon={Award} title="Nothing recorded yet" message="You have no training records or requirements." />
      ) : (
        <div className="cc-card divide-y" data-testid="my-training-list">
          {data.items.map((it, i) => (
            <div key={i} className="flex items-center justify-between p-3.5" data-testid={`my-training-item-${i}`}>
              <div><div className="font-medium text-slate-800">{it.name}</div>
                <div className="text-xs text-slate-500">{it.record?.expiry_date ? `Expires ${it.record.expiry_date}` : it.record?.completion_date ? `Completed ${it.record.completion_date}` : "Not completed"}{it.required ? " · required" : ""}</div></div>
              <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${STATUS_STYLE[it.status] || "bg-slate-100"}`}>{it.status}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
